import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

/**
 * Turns the `to` handed over with the session into a path inside the app.
 * The backend returns whatever the sender asked for without checking it, so
 * anything that leaves this origin falls back to the home page.
 */
export function resolveHandoffDestination(to: string | undefined, origin: string): string {
  const fallback = ROUTE_PATHS[RouteName.ROOT];

  if (!to) return fallback;

  try {
    const url = new URL(to, origin);

    if (url.origin !== origin) return fallback;

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
